<template>
    <!-- LOADING -->
    <div class="d-flex flex-column mt-2" v-if="isLoading">
        <div class="d-flex flex-column w-100 mt-3" v-for="i in 3" :key="`loading-${i}`">
            <span class="shimmer-loading w-100 py-3 mb-2"></span>
            <span class="shimmer-loading w-80 py-3 mb-2" v-for="i in 2" :key="`shimmer-${i}`"> </span>
        </div>
    </div>
    <!-- ERROR -->
    <div class="mt-5" v-if="hasError && !isLoading">
        <p>There was an error while getting your agencies.<br />Please try again.</p>
        <button class="btn btn-primary btn-sm" @click="reloadAgencies()">Try Again</button>
    </div>
    <!-- AGENCY LIST -->
    <section id="App__Agencies_Vue" v-if="!hasError && !isLoading">
        <!-- HOSPICE MARKETING LINK -->
        <template v-if="isBeforeHosMarketingLastDate && groupedAgencies.size">
            <header class="text-app-primary group-title-vue no-pointer" id="hospiceMarketing">AxxessHospice</header>
            <a
                href="javascript:void(0)"
                class="btn btn-hospice-primary d-block w-100 fw-bold"
                @click="openHospiceMarketingLink()"
            >
                Learn More
            </a>
        </template>
        <!-- AGENCY BY PRODUCT -->
        <template v-for="[applicationName, list] in groupedAgencies" :key="applicationName">
            <header class="group-title-vue" :id="applicationName" @click="showAgency(list)">
                <span :class="getProductColorClass(applicationName)">{{ applicationName }}</span>
                <i :class="`me-1 ms-auto arrow-color fas fa-caret-${list.show ? 'down' : 'up'}`"></i>
            </header>
            <button
                v-for="(agency, index) in list.data"
                :key="`agency-btn-${index}`"
                :class="`btn btn-vue btn-block-vue ${applicationName} font-size-base ${getProductColorClass(
                    applicationName
                )}`"
                @click="enterAgency(agency)"
                v-show="agency && list.show"
            >
                {{ agency.Name }}
            </button>
        </template>
    </section>
</template>

<script lang="ts" src="./AgencyList.ts"></script>
<style src="./AgencyList.scss"></style>
